const autoNgTemplateLoaderTemplate1 = require('./filesDatatable.html');

import angular from 'angular';

angular.module('portainer.agent').component('filesDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'GenericDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    dataset: '<',
    tableKey: '@',
    orderBy: '@',
    reverseOrder: '<',

    isRoot: '<',
    goToParent: '&',
    browse: '&',
    rename: '&',
    download: '&',
    delete: '&',

    isUploadAllowed: '<',
    onFileSelectedForUpload: '<',
  },
});
